import * as L from "leaflet";
export default class ControlsUI {
  constructor(awesomeMap) {
    this.awesomeMap = awesomeMap;
    this.main = L.control.layers(null, null, {
      position: "topleft",
      sortLayers: false,
      collapsed: this.awesomeMap.config.collapsedMenu
      // hideSingleBase: true
    });
    if (this.awesomeMap.config.hideControls) {
      this.main.getContainer().style.display = "none";
    }
    this.loading = document.querySelector("#awesome-map .loading-spinner");
    this.onHashtag = this._orderHashtags;
    this.awesomeMap.map.on("overlayadd", () => {
      this.removeHiddenCategories();
    });
  }
  attach() {
    this.main.addTo(this.awesomeMap.map);
    this.addSearchControls();
    if (this.awesomeMap.config.menu.categories) {
      this.addCategoriesControls();
    }
    $("#awesome-map").on("click", ".awesome_map-title-control", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const categories = document.getElementById("awesome_map-categories-control");
      const hashtags = document.getElementById("awesome_map-hashtags-control");
      if (categories) {
        categories.classList.toggle("active");
      }
      if (hashtags) {
        hashtags.classList.toggle("active");
      }
    });
    $("#awesome-map").on("change", ".awesome_map-hashtags-selector", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const tag = $(evt.target).closest("label").data("layer");
      if (tag) {
        this.updateHashtagLayers();
      }
    });
    $("#awesome-map").on("click", ".awesome_map-toggle_all_tags", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      $("#awesome-map .awesome_map-hashtags-selector").prop("checked", $("#awesome-map .awesome_map-hashtags-selector:checked").length < $("#awesome-map .awesome_map-hashtags-selector").length);
      this.updateHashtagLayers();
    });
    this.awesomeMap.map.on("popupopen", () => {
      document.querySelector(".leaflet-control-layers.leaflet-control").style.display = "none";
    });
    this.awesomeMap.map.on("popupclose", () => {
      document.querySelector(".leaflet-control-layers.leaflet-control").style.display = "block";
    });
  }
  addSearchControls() {
    const section = this.main.getContainer().querySelector(".leaflet-control-layers-list");
    if (section) {
      section.insertAdjacentHTML("beforeend", `<div id="awesome_map-categories-control" class="active"><b class="awesome_map-title-control">${window.DecidimAwesome.i18n.categories}</b><div class="categories-container"></div></div>
    <div id="awesome_map-hashtags-control"><b class="awesome_map-title-control">${window.DecidimAwesome.i18n.hashtags}</b><div class="hashtags-container"></div><a href="#" class="awesome_map-toggle_all_tags">${window.DecidimAwesome.i18n.selectDeselectAll}</a></div>`);
    } else {
      console.error("Can't find the section to insert the controls");
    }
  }
  addCategoriesControls() {
    this.awesomeMap.categories.forEach((category) => {
      const label = `<i class="awesome_map-category_${category.id}"></i> ${category.name}`;
      this.awesomeMap.layers[category.id] = {
        label,
        group: new L.FeatureGroup.SubGroup(this.awesomeMap.cluster)
      };
      this.awesomeMap.layers[category.id].group.addTo(this.awesomeMap.map);
      const categories = document.querySelector("#awesome_map-categories-control .categories-container");
      if (categories) {
        categories.insertAdjacentHTML("beforeend", `<label data-layer="${category.id}" class="awesome_map-category-${category.id}${category.parent ? " subcategory" : ""}" data-parent="${category.parent}"><input type="checkbox" class="awesome_map-categories-selector" checked><span>${label}</span></label>`);
      } else {
        console.error("Can't find the section to insert the categories");
      }
    });
    $("#awesome-map").on("change", ".awesome_map-categories-selector", (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const id = $(evt.target).closest("label").data("layer");
      const cat = this.awesomeMap.getCategory(id);
      if (cat) {
        const layer = this.awesomeMap.layers[cat.id];
        if (evt.target.checked) {
          this.awesomeMap.map.addLayer(layer.group);
        } else {
          this.awesomeMap.map.removeLayer(layer.group);
        }
        this._indeterminateParentInput(cat);
        this.updateHashtagLayers();
      }
    });
  }
  // Hashtags are collected directly from proposals (this is different than categories)
  addHashtagsControls(hashtags, marker) {
    if (hashtags && hashtags.length) {
      document.getElementById("awesome_map-hashtags-control").style.display = "block";
      hashtags.forEach((hashtag) => {
        if (!this.awesomeMap.layers[hashtag.tag]) {
          this.awesomeMap.layers[hashtag.tag] = {
            label: hashtag.name,
            group: new L.FeatureGroup.SubGroup(this.awesomeMap.cluster)
          };
          this.awesomeMap.map.addLayer(this.awesomeMap.layers[hashtag.tag].group);
          document.querySelector("#awesome_map-hashtags-control .hashtags-container").insertAdjacentHTML("beforeend", `<label data-layer="${hashtag.tag}" class="awesome_map-hashtag-${hashtag.tag}"><input type="checkbox" class="awesome_map-hashtags-selector" checked><span>${hashtag.name}</span></label>`);
          this.onHashtag(hashtag, $("#awesome_map-hashtags-control .hashtags-container"));
        }
        this.awesomeMap.layers[hashtag.tag].group.addLayer(marker);
        const label = document.querySelector(`label.awesome_map-hashtag-${hashtag.tag}`);
        label.setAttribute("title", `${parseInt(label.title || 0, 10) + 1} ${window.DecidimAwesome.i18n.items}`);
      });
    }
  }
  showCategory(cat) {
    document.getElementById("awesome_map-categories-control").style.display = "block";
    const label = document.querySelector(`label.awesome_map-category-${cat.id}`);
    const parent = document.querySelector(`label.awesome_map-category-${cat.parent}`);
    if (label) {
      label.style.display = "block";
      label.setAttribute("title", `${parseInt(label.title || 0, 10) + 1} ${window.DecidimAwesome.i18n.items}`);
    }
    if (parent) {
      parent.style.display = "block";
      parent.setAttribute("title", `${parseInt(parent.title || 0, 10) + 1} ${window.DecidimAwesome.i18n.items}`);
    }
  }
  removeHiddenComponents() {
    $(".awesome_map-component").each((_idx, el) => {
      const layer = this.awesomeMap.layers[$(el).data("layer")];
      const $input = $(el).closest("div").find("input:not(:checked)");
      if (layer && $input.length) {
        this.awesomeMap.map.addLayer(layer.group);
        this.awesomeMap.map.removeLayer(layer.group);
      }
    });
  }
  removeHiddenCategories() {
    $(".awesome_map-categories-selector:not(:checked)").each((_idx, el) => {
      const layer = this.awesomeMap.layers[$(el).closest("label").data("layer")];
      if (layer) {
        this.awesomeMap.map.addLayer(layer.group);
        this.awesomeMap.map.removeLayer(layer.group);
      }
    });
  }
  updateHashtagLayers() {
    $(".awesome_map-hashtags-selector").each((_idx, el) => {
      const layer = this.awesomeMap.layers[$(el).closest("label").data("layer")];
      if (layer) {
        this.awesomeMap.map.removeLayer(layer.group);
      }
    });
    $(".awesome_map-hashtags-selector:checked").each((_idx, el) => {
      const layer = this.awesomeMap.layers[$(el).closest("label").data("layer")];
      if (layer) {
        this.awesomeMap.map.addLayer(layer.group);
      }
    });
    this.removeHiddenComponents();
    this.removeHiddenCategories();
  }
  updateStats(uid, total) {
    const $component = $(`#awesome_map-${uid}`);
    $component.attr("title", `${total} ${window.DecidimAwesome.i18n.items}`);
  }
  _indeterminateParentInput(cat) {
    if (cat.parent) {
      let $input = $(`.awesome_map-category-${cat.parent}`).contents("input");
      let $subcats = $(`[class^="awesome_map-category-"][data-parent="${cat.parent}"]:visible`);
      let numChecked = $subcats.contents("input:checked").length;
      $input.prop("indeterminate", numChecked !== $subcats.length && numChecked !== 0);
    }
  }
  // order hashtags alphabetically
  _orderHashtags(_hashtag, $div) {
    let $last = $div.contents("label:last");
    if ($last.prev("label").length) {
      $div.contents("label").each((_idx, el) => {
        if ($(el).text().localeCompare($last.text()) > 0) {
          $(el).before($last);
        }
      });
    }
  }
}
